@if (formControl()) {
<div class="password form-group">
    <mat-form-field class="form-field">
        <input matInput [placeholder]="$safeNavigationMigration(meta()?.name)" [formControl]="formControl()!" [type]="hide ? 'password' : 'text'"
            [readonly]="readonly() || meta()?.readonly">
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        @if (meta()?.info) {
        <mat-hint><strong>{{meta()?.info}}</strong></mat-hint>
        }
        @if (formControl()?.hasError('required')) {
        <mat-error>
            Password is <strong>required</strong>
        </mat-error>
        }
    </mat-form-field>
</div>
}
